<template>
  <div class="ringba-integration-container mx-auto d-flex flex-column flex-grow-1 py-5">
    <div class="mx-3">
      <h2 class="text-center mb-4 text-white">
        Connect Your Ringba Account
      </h2>
      <p class="text-center text-muted mb-4 ringba-integration__sub-title">
        Integrate your Ringba account to facilitate creation of Ring Tree Targets for approved offers.
      </p>
      
      <ManageRingbaApiToken 
        ref="ringbaIntegration"
        @integration-complete="onIntegrationComplete"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import onboardingMixin from '@/mixins/onboarding.mixin'
import ManageRingbaApiToken from '@/components/ringba-integration/ManageRingbaApiToken.vue'

export default {
  name: 'RingbaIntegrationOnboarding',

  onboardingStep: 'ringba',

  title: 'Ringba Integration Setup',

  components: {
    ManageRingbaApiToken
  },

  mixins: [onboardingMixin],

  computed: {
    ...mapGetters('auth', ['accountId', 'ringbaAccountId']),

    ...mapGetters('account', [
      'accountHasRingbaIntegrationCompleted'
    ]),
  },

  watch: {
    // Watch for changes to ringbaAccountId in case it gets set while on this page
    accountHasRingbaIntegrationCompleted: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.onIntegrationComplete()
        }
      }
    }
  },

  methods: {
    onIntegrationComplete() {
      // Integration is complete, proceed to admin approval
      this.$router.push({ name: 'AdminApprovalPending' })
    }
  }
}
</script>

<style lang="scss" scoped>
.ringba-integration-container {
  max-width: 800px;
  
  .ringba-integration__sub-title {
    font-size: 1.05rem;
  }
}
</style>